/* wx相关配置和业务 */

import { isWechat, isWeChatMini } from "tools/utils/UA";
import request from "./request";
import { captureExceptionByWx } from "tools/utils/dataReport";
import { wechartAppid } from "./config";

// 微信内需要使用的JS接口列表
const jsApiListForWechat = [
    'checkJsApi',
    'updateAppMessageShareData',
    'updateTimelineShareData',
    'onMenuShareWeibo',
    'closeWindow'
];

// 微信内需要使用的开放标签列表，目前没有使用
// https://developers.weixin.qq.com/community/develop/article/doc/000c00b4490678f528baf2cf756413
const openTagListForWechat = [
    'wx-open-launch-weapp'
];

/**
 * 获取当前页面url，获取签名时候需要给后端传(可以不带hash  但是必须带search)
 */
const getCurPageUrl = () => {
    return `${window.location.origin}${window.location.pathname}${window.location.search}`;
};

/**
 * 从服务端获取初始化wx.config方法需要的字段
 * 测试h5微信配置sdk的相关内容，需要将域名改成haojie.test.58.com, 这个域名加入了测试公众号的白名单里面
 */
const getSignnatureByServe = () => {
    return new Promise((resolve, reject) => {
        const pageUrl = getCurPageUrl();
        // 请求签名
        request.get('/wechat/api/share/get', {
        // request.get(ApiMapV2.getWXConfig, {
            url: pageUrl,
            appId: wechartAppid,
        }).then(res => {
            if (res.code === 0 && res.data) {
                const { nonceStr, timestamp, signature } = res.data;
                if (nonceStr && timestamp && signature) {
                    resolve({ nonceStr, timestamp, signature });
                } else {
                    reject(new Error('error'));
                }
            } else {
                reject(new Error('error'));
            }
        }).catch(error => {
            reject(error);
        });
    });
};

/**
 * 初始化微信权限验证配置
 */
const initWecharConfig = async () => {
    // 不是微信
    if (!isWechat()) return;

    let _jsApiListForWechat = jsApiListForWechat;
    let _openTagListForWechat = openTagListForWechat;
    if (await isWeChatMini()) {
        // 是微信小程序
        _jsApiListForWechat = ['getLocation'];
        _openTagListForWechat = [];

    }

    console.log("wx.reading--config--_jsApiListForWechat,", _jsApiListForWechat);

    const wx = window.wx;
    try {
        const data: any = await getSignnatureByServe();
        
        const { nonceStr, timestamp, signature } = data;
        wx && wx.config({
            debug: false, // NOT_PRD_ENV, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: wechartAppid, // 必填，公众号的唯一标识
            timestamp, // 必填，生成签名的时间戳
            nonceStr, // 必填，生成签名的随机串
            signature, // 必填，签名
            jsApiList: _jsApiListForWechat, // 必填，需要使用的JS接口列表
            openTagList: _openTagListForWechat // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
        });

    } catch (error) {
        // 获取失败以后  暂时什么也不处理吧
        console.log("wx.reading--config--error,", error);
        captureExceptionByWx({ message: 'wx.config error', error: `wx.config:${error}` });
    }

    wx && wx.ready(() => {
        console.log('wx.reading--config---success');
    });
    wx && wx.error(res => {
        // config验证失败后的处理  暂时不需要处理
        console.log('wx.error===>', res);
        captureExceptionByWx({ message: 'wx.config error', error: JSON.stringify(res) });
    });
    // })
};


/**
 * 校验当前是否微信小程序，返回代理域名
 * @returns 域名
 */
export const getFaceIdDomain = async () => {
    if (await isWeChatMini()) {
        return 'faceid.58.com';
    } else {
        return 'api.megvii.com';
    }
}

/**
 * app下页面跳转之前对url进行处理
 * 因为不带协议的话跳转会失败
 */
export function fomatLoadUrl(url) {
    const _origin = window.location.origin;
    const _protocol = window.location.protocol;
    if (url.indexOf('//') === 0) {
        return `${_protocol}${url}`;
    } else if (url.indexOf('http:') !== 0 && url.indexOf('https:') !== 0) {
        return `${_origin}${url}`;
    }
    return url;
}

/**
 * 用于存储当前微信环境值
 */
export class WxMiniConfig {
    private app_key = ''
    private static instance: WxMiniConfig | null = null;

    static newInstance() {
        if (this.instance === null) {
            this.instance = new WxMiniConfig();
        }
        return this.instance;
    }

    setAppkey(app_key) {
        this.app_key = app_key;
    }

    getAppkey() {
        return this.app_key;
    }
}

export default initWecharConfig;